export default __webpack_public_path__ + "static/media/p3.41662797.jpg";